import { render } from "./SearchIcon.vue?vue&type=template&id=4df4de96&ts=true"
import script from "./SearchIcon.vue?vue&type=script&lang=ts"
export * from "./SearchIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__